import axios from 'axios'
import { AppBox, AppDialog, AppIcon, AppTypography, EmailText } from 'components'
import { useSnackbar } from 'notistack'
import { FC, useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'store/app.store'
import { CommonSliceSelector, setIsTooManyHitsDialogShown } from 'store/slices/common.slice'

interface Props {}

export const TooManyHitsDialog: FC<Props> = () => {
  const { isTooManyHitsDailogShown } = useSelector(CommonSliceSelector)
  const dispatch = useAppDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const [ipAd, setIP] = useState('')

  //creating function to load ip address from the API
  const getData = async () => {
    const res = await axios.get('https://api.ipify.org?format=jsonp?callback=?')
    setIP(res.data)
  }

  useEffect(() => {
    //passing getData method to the lifecycle method
    getData()
  }, [])
  const generateCode = useMemo(() => {
    const randomString = Math.random().toString(36).slice(2, 8)
    return randomString + ipAd.replaceAll('.', 'e')
  }, [ipAd])
  const handleCopyParkNo = () => {
    enqueueSnackbar('Copied to clipboard', { variant: 'info' })
    navigator.clipboard.writeText(generateCode)
  }
  return (
    <AppDialog
      open={isTooManyHitsDailogShown}
      onClose={() => dispatch(setIsTooManyHitsDialogShown(false))}
      title="Contact Support"
      renderChild={() => (
        <AppTypography fontSize={14}>
          It looks like there's an issue with your account. Please contact us at{' '}
          <EmailText email="support@parksites.io" /> to resolve this issue. Make sure your email's subject line contains
          the following <code className=""></code>
          <AppBox display={'flex'} alignItems={'center'} paddingTop={2} gap={2}>
            <AppBox backgroundColor={'primary.200'} height={10} width={10} borderRadius={50} />
            <AppTypography fontSize={14}>{generateCode}</AppTypography>
            <AppIcon icon={'mynaui:copy'} onClick={handleCopyParkNo} color="blue" />
          </AppBox>
        </AppTypography>
      )}
    />
  )
}
